import { store } from '@/store/store'
import axios from 'axios'
import config from '../config'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}zwiz-gpf-buddy`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const gpfBuddyApi = {
  getCompanyMasterData: (request) => {
    const { config } = request
    return instance().get('/cms/intents/company-info', {
      params: config
    })
  },
  getMember: (request) => {
    const { config } = request
    return instance().get('/cms/employee/registered-users', config)
  },
  postSyncEmployee: (request) => {
    const { data } = request
    return instance().post('/cms/employee/sync-registered-users', data)
  },
  postSyncCompany: (request) => {
    const { data } = request
    return instance().post('/cms/company/sync-company-info', data)
  }
}
export default gpfBuddyApi



// WEBPACK FOOTER //
// ./src/api/gpf-buddy.js